import { appConfig } from '@config';
import axiosInstance from '@helpers/api/axiosInstance';
import failErrorResponse from '@helpers/api/httpResponse';
import { setHeaders } from '@helpers/api/setHeaders';
import successResponse from '@helpers/api/successResponse';

/**
 * DELETE request
 * @param {string} path - URL path
 * @param {*} [payload] - Request payload
 * @param {Object} [$2={}] - Configuration options.
 * @param {Object<string,*>|{}} [$2.axiosOptions] - Extra axios config options
 * @param {Object<string,string>|{}} [$2.additionalHeaders] - Pass additional headers which can overwrite current values
 * @returns {Promise<*>}
 */

const deleteRequest = async (
  path,
  payload = {},
  { additionalHeaders = {}, axiosOptions = {} } = {}
) =>
  axiosInstance
    .delete(`${appConfig.apiUrl}/${path}`, {
      data: { ...payload },
      headers: setHeaders(additionalHeaders),
      ...axiosOptions,
    })
    .then(successResponse)
    .catch(failErrorResponse);

export default deleteRequest;
